import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Repo from "../../Repository/Repo";
import moment from "moment";
import { findExpireDays } from "../../utils/findExpireDays";

const initialState = {
  loading: true,
  error: "",
  expiryDate: null,
  status: null,
  trialExpired: null,
  country: "",
};

export const getTrial = createAsyncThunk("trial/fetchtrial", async () => {
  return await Repo.user({
    request: {
      method: "getUserTrialsDetails",
      data: {
        user: {
          email: localStorage.getItem("email"),
        },
      },
    },
  })
    .then(({ data }) => data.response.data)
    .catch((err) => console.log(err));
});

export const trialSlice = createSlice({
  name: "trial",
  initialState,
  reducers: {
    addTrial: (state, action) => {
      const { expiryDate, isTrial } = action.payload;
      state.expiryDate = expiryDate;
      console.log("expiry date", expiryDate);
    },
    handleLoading: (state, action) => {
      state.loading = false;
    },
    clearTrial: (state) => {
      state.expiryDate = null;
    },
    endTrial: (state) => {
      state.expiryDate = null;
      state.status = "Trial Ended";
    },
    userPaid: (state) => {
      state.status = "Paid";
      state.expiryDate = null;
    },
    trailRemoved: (state) => {
      state.status = "nill";
    },
    addCountry: (state) => {
      state.country = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTrial.pending, (state) => {
      state.loading = true;
      console.log("pending");
      console.log("statussss pending", state.status);
    });
    builder.addCase(getTrial.fulfilled, (state, action) => {
      console.log("fullll", action.payload);
      state.loading = false;
      state.error = "";

      if (action.payload?.isTrial) {
        const { isTrial, trialExpireDate } = action.payload;
        console.log("isTrail", isTrial);
        const expireDays = findExpireDays(trialExpireDate);
        console.log("Expire Days:", expireDays);

        if (findExpireDays(trialExpireDate) > 0) {
          state.status = "Trial";
          state.expiryDate = action.payload.trialExpireDate;
          console.log("expppire", action.payload);
        } else {
          state.status = "Trial Ended";

          console.log("trail ended");
        }
      } else if (action.payload?.isPaid) {
        state.status = "Paid";
        state.expiryDate = null;
        console.log("padiiiidd", action.payload.isPaid);
      } else if (!action.payload?.isTrial && !action.payload?.isPaid) {
        console.log("paidddwdsa");
        // if(state.loading == false && localStorage.getItem("email"))  {
        // state.status = action.payload.trialExpired;
        if (localStorage.getItem("email") && action.payload.trialExpired) {
          state.status = "Trial Ended";
          localStorage.clear();
          window.location.href = "/inventory/login";
        }
      }
    });
    builder.addCase(getTrial.rejected, (state, action) => {
      state.loading = false;
      state.expiryDate = null;
      state.status = null;
      state.error = action.error.message;
    });
  },
});

export const {
  handleTrial,
  endTrial,
  addTrial,
  clearTrial,
  handleLoading,
  userPaid,
  trailRemoved,
  addCountry,
} = trialSlice.actions;

export default trialSlice.reducer;
